import Suche from './Suche';

export default Suche;
